import React, { useState, useEffect } from 'react';
import { Form, Button, Container, Alert } from 'react-bootstrap';
import { useSearchParams } from 'react-router-dom';

const SetPasswordPage = () => {
  const [searchParams] = useSearchParams();
  const [formData, setFormData] = useState({
    password: '',
    confirmPassword: ''
  });
  const [error, setError] = useState('');
  const [success, setSuccess] = useState(false);

  const token = searchParams.get('token');

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prevData => ({
      ...prevData,
      [name]: value
    }));
    setError('');
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    // Validate passwords match
    if (formData.password !== formData.confirmPassword) {
      setError('Passwords do not match');
      return;
    }

    // Validate password length
    if (formData.password.length < 8) {
      setError('Password must be at least 8 characters long');
      return;
    }

    try {
      const response = await fetch(`${process.env.REACT_APP_API_URL}/set-password`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          password: formData.password,
          token: token
        })
        
      });
      if (!response.ok) {
        throw new Error('Failed to set password');
      }

      setSuccess(true);
      setFormData({ password: '', confirmPassword: '' });
    } catch (err) {
      setError(err.message);
    }
  };

  if (!token) {
    return (
      <Container className="mt-5">
        <Alert variant="danger">
          Invalid or missing token. Please check your reset password link.
        </Alert>
      </Container>
    );
  }

  return (
    <Container className="mt-5">
      <div className="max-w-md mx-auto">
        <h2 className="mb-4">Set New Password</h2>
        
        {error && (
          <Alert variant="danger" className="mb-4">
            {error}
          </Alert>
        )}
        
        {success && (
          <Alert variant="success" className="mb-4">
            Password successfully updated!
          </Alert>
        )}

        <Form onSubmit={handleSubmit}>
          <Form.Group className="mb-3">
            <Form.Label>New Password</Form.Label>
            <Form.Control
              type="password"
              name="password"
              value={formData.password}
              onChange={handleChange}
              placeholder="Enter new password"
              required
              minLength={8}
            />
          </Form.Group>

          <Form.Group className="mb-3">
            <Form.Label>Confirm Password</Form.Label>
            <Form.Control
              type="password"
              name="confirmPassword"
              value={formData.confirmPassword}
              onChange={handleChange}
              placeholder="Confirm new password"
              required
              minLength={8}
            />
          </Form.Group>

          <Button variant="primary" type="submit">
            Set Password
          </Button>
        </Form>
      </div>
    </Container>
  );
};

export default SetPasswordPage;